export const environment = {
  production: true,
  tableauURI:  'https://tableau-extd.labcorp.com'
};
